// This app's one `@bindery/auth-consumer` instance.
//
// The consumer is built once, at module scope, and lives here rather than in
// ./index.ts so that the modules which only need its LOGGER — ./api-log.ts and
// ./visitor.ts — can import it without importing the Worker entry that imports
// them. A logger re-exported from ./index.ts would be exactly that cycle.
//
// Everything that used to be ./auth.ts, ./cookies.ts, ./exchange.ts,
// ./verify.ts and ./return-to.ts is now the package; what stays retells' own
// is the four-line description below plus the routes in ./index.ts.

import { createAuthConsumer } from "@bindery/auth-consumer";
import { canonicalHost, hostsOf, SOURCE_PEERS } from "@bindery/topology";

export const consumer = createAuthConsumer({
  service: "retells",
  brand: "Retells",
  // Cookies ignore ports, so on the `localhost` dev peer the broker and every
  // consumer would otherwise clobber one shared host-only name.
  cookiePrefix: "retells",
  // Every host retells is served on, at every target. One list, three jobs:
  // the auth host gate, the absolute-`returnTo` allowlist, and what
  // ../wrangler.jsonc's routes must actually attach (scripts/wrangler.test.ts
  // checks the two against the same topology).
  hosts: hostsOf("retells"),
  // Where a request arriving on a host nothing here serves is funnelled.
  defaultHost: canonicalHost("retells", "prod"),
  // The monorepo's live brokers, reached only by a deploy that states no
  // `AUTH_*` vars (every scope in ../wrangler.jsonc states its own). They
  // stay the fallback because they are the one set that can still complete a
  // sign-in, until kanban #69's live loop is proven and `allowedPeersFor`
  // drops them.
  defaultPeers: SOURCE_PEERS,
});

/**
 * Structured logging bound to retells' `service` discriminator. Retells shares
 * read-by-ear's Axiom dataset and `docs/ops/logging.md` tells operators to
 * lead every query with `['service'] == "retells"`, so every emitter in this
 * worker — auth, `/api/log`, `/api/visitor` — must go through this one.
 */
export const log = consumer.log;
